import React, { useState, useContext } from 'react';
import '../styles/projects.css';
import ProjectCard from '../components/ProjectCard';
import DataContext from '../contexts/DataContext';
import { useTranslation } from 'react-i18next';

const Projects = () => {

  const { t } = useTranslation('projects');

  const { projects, people, isLoading } = useContext(DataContext);
  const [filters, setFilters] = useState({
    area: '',
  });
  const [searchTerm, setSearchTerm] = useState('');

  const handleFilterChange = (filterName, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: value
    }));
  };

  const handleSearchTermChange = event => {
    setSearchTerm(event.target.value);
  };

  let filteredProjects = projects;
  filteredProjects = filteredProjects.filter(project => {
    return (
      (filters.area === '' || project.area === filters.area) &&
      ((project.title && project.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (project.description && project.description.toLowerCase().includes(searchTerm.toLowerCase())))
    );
  });

  return (
    <div className="proyectos container">
      <h1>{t('title')}</h1>
      <div className="filters">
        <select value={filters.area} onChange={e => handleFilterChange('area', e.target.value)}>
          <option value="">{t('nav-option-1')}</option>
          <option value="Human Computer Interaction">{t('nav-option-2')}</option>
          <option value="Image Processing">{t('nav-option-3')}</option>
          <option value="Mixed Realities">{t('nav-option-4')}</option>
          <option value="Robotics">{t('nav-option-5')}</option>
          <option value="Visual Analytics">{t('nav-option-6')}</option>
          <option value="Video Games">{t('nav-option-7')}</option>
        </select>
        <input
          type="text"
          placeholder={t('placeholder')}
          value={searchTerm}
          onChange={handleSearchTermChange}
        />
      </div>
      <div className="row">
        {isLoading ? (
          Array(10).fill().map((_, index) => (
            <ProjectCard key={index} isLoading={isLoading} verMas={true} />
          ))
        ) : (
          filteredProjects.map((project, index) => (
            <ProjectCard key={index} project={project} peopleInfo={people} area={true} verMas={true} isLoading={isLoading} />
          ))
          
        )}
      </div>
    </div>
  );
};

export default Projects;
